module.exports = __webpack_public_path__ + "static/media/duck.544bbc3f.svg";